import { Component, Input, OnDestroy } from '@angular/core';
import { AppConfigService } from '../../services/config/app-config.service';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { CommonUtilService } from '../../services/common-util/common-util.service';
import { RoutePermission } from '../../services/raintree/interfaces/permission.interface';
import { RequestMapper } from '../../request-mapper';
import { resolve } from 'node:path';
import { CommonModule } from '@angular/common';
import { url } from 'node:inspector';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-dp-tab-menu-v3',
  standalone: true,
  imports: [RouterModule,CommonModule],
  templateUrl: './dp-tab-menu-v3.component.html',
  styleUrl: './dp-tab-menu-v3.component.scss'
})
export class DpTabMenuV3Component implements OnDestroy {
  constructor(private _appConfig: AppConfigService, private _router: Router, private isMobile: CommonUtilService) { }

    isMobileDevice: boolean = false;
    permissionTab!: RoutePermission[];
    @Input() showMasterSearch?: boolean = false;
    @Input() isBreadCrumbPresent?: boolean = false;
    urlRouteParams: any = []
    private _routerSub!: Subscription;

    ngOnInit(): void {
      this.isMobileDevice = this.isMobile.isMobileDevice();
      this.fetchTabDetails();
      this._routerSub = this._router.events
        .pipe(filter(e => e instanceof NavigationEnd))
        .subscribe(() => {
          this.urlRouteParams = this._router.url.split('/');
        });
    }

    ngOnDestroy(): void {
      this._routerSub?.unsubscribe();
    }
  
    fetchTabDetails() {
      this.urlRouteParams = this._router.url.split('/');
      console.log(this.urlRouteParams,'What are url route params ....?');
      let permissionTab = this._appConfig.getAllPermissionsV3();
      console.log(permissionTab,'Perms from db -------------->');

      if(this.urlRouteParams[1] === RequestMapper.DASHBOARD || this.urlRouteParams[1] === RequestMapper.WORK_HISTORY || this.urlRouteParams[1] === RequestMapper.OBLATE_REGISTER){
        permissionTab = Object.values(permissionTab).find((elem:any)=> elem.default?.webRoute === this.urlRouteParams[1] && elem.default?.viewType !== 'T');
        console.log(permissionTab,'permission---------tab');
        let fwCheck:any = Object.values(permissionTab).filter((item)=> (item.default?.webRoute === RequestMapper.WORK_UPDATE_HISTORY) && this.urlRouteParams[1]=== RequestMapper.WORK_HISTORY);
        
        const default_route = Object.entries(permissionTab).find(([key,item])=> key !== 'default');
        const default_route_string = default_route ? default_route[1].default.webRoute : '';
        
        let route = this.urlRouteParams[1] + '/' + default_route_string;
        if(this.urlRouteParams[1] === RequestMapper.WORK_HISTORY) {
          if (this.urlRouteParams[2]) {
            // Already on a specific child — keep the current URL, don't redirect
            route = '';
          } else {
            let localStoreRoute = localStorage.getItem('dpAddedType');
            route = this.urlRouteParams[1] + '/' + (localStoreRoute ? RequestMapper.MY_OBLATES : default_route_string);
          }
        }
        if (route) this._router.navigate([route]);
      }
      else{
        for(let i=1;i < this.urlRouteParams.length - 1; i++){
          const tempPermTab = Object.values(permissionTab).find((elem:any)=> elem.default?.webRoute === this.urlRouteParams[i] && elem.default?.viewType !== 'T');
          console.log(tempPermTab)
          permissionTab = tempPermTab
        }
      }
      this.permissionTab = Object.entries(permissionTab).filter(([key,elem])=> key!=='default').map((elem)=> elem[1].default);
      console.log('Tab webRoutes:', this.permissionTab.map((t: any) => ({ label: t.labelName, webRoute: t.webRoute })));
    }
  
    shouldNavigate(rout: RoutePermission) {
      let presentUrl: String[] = this._router.url.split(/\/|\?/);
      if (presentUrl.includes(rout.webRoute)) {
        return false;
      }
      return true;
    }
}
